<template>
  <div class="range-limit">
    <div class="text-signup-limit">
      <div class="text-size-12 text-left">{{ $t('options.signupLimit') }}</div>
      <v-select
        ref="limit"
        :disabled="!this.poll.options.limitedVotesPerChoiceSpecific"
        :options="rangeLimitOptions"
        :appendToBody="false"
        :clearable="true"
        :searchable="false"
        :value="value"
        @input="setLimit"
        :reduce="(title) => title.code"
        label="title"
      ></v-select>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { mapState } from 'vuex';

export default {
  name: 'ChoiceLimit',

  props: ['value'],

  components: {
    vSelect,
  },

  watch: {
    noLimitLabel() {
      this.setLimit(1);
      this.$nextTick(() => {
        this.setLimit(0);
      });
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
    }),
    noLimitLabel() {
      if (this.poll.options.limitedVotesPerChoiceSpecific) {
        return 'no limit';
      }
      return 'Premium only';
    },
    rangeLimitOptions() {
      let list = [];
      list.push({ code: null, title: this.noLimitLabel });
      for (let i = 1; i <= 100; i++) {
        list.push({ code: i, title: `${i}` });
      }
      return list;
    },
  },

  methods: {
    setLimit(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/style.scss';
.text-signup-limit {
  width: 140px;
  margin-right: 12px;
}
</style>
